import React, {memo} from "react";
import {Checkbox} from "antd";

interface MemoizCheckBoxProps {
    checked: boolean;
}


const MemoizedCheckBox:React.FC<MemoizCheckBoxProps>  = memo(({ checked }) => (
    <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Checkbox checked={checked} />
    </div>
));
export default MemoizedCheckBox;